<div *ngIf="data" class="close">
  <mat-icon (click)="close()">close</mat-icon>
</div>
<h3 *ngIf="data" class="row col-sm-12 warning">
  {{ data.message }}<br />
  <small *ngIf="data">clique no botão [ + Novo curso ]</small>
</h3>
<div class="content">
  <div class="col-left">
    <mat-action-list>
      <h3 matSubheader>Meu histórico</h3>
      <ng-container *ngFor="let education of educations$ | async">
        <button mat-list-item (click)="editEducation(education)" [ngClass]="{
            selected: education.id == formEducation.get('id').value
          }">
          <h3 matLine>
            {{ education.course_name }} - {{ education.institution_name }}
          </h3>
          <p matLine>
            <span>de {{ education.date_start | date : "MM/yyyy" }} até
              {{ (education.date_end | date : "MM/yyyy") || "o momento" }}</span>
          </p>
          <button type="button" mat-icon-button color="warn" (click)="removeEducation(education)">
            <mat-icon>remove</mat-icon>
          </button>
        </button>
      </ng-container>
      <ng-container *ngIf="(educations$ | async)?.length === 0">
        <button
          mat-list-item style="
          background: #f3f2f2;
      ">
          <h3 matLine>Nenhuma curso encontrado.</h3>
        </button>
      </ng-container>
    </mat-action-list>
  </div>

  <div class="col-right">
    <form [formGroup]="form" (submit)="submitLevelEducattion()">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Nível educacional</mat-label>
          <mat-select placeholder="Selecione um nivel educacional" formControlName="Leveleducation">
            <mat-option value="ens-sup-nivel4">Ensino Superior (Doutorado)</mat-option>
            <mat-option value="ens-sup-nivel3">Ensino Superior (Mestrado)</mat-option>
            <mat-option value="ens-sup-nivel2">Ensino Superior (Pós graduação)</mat-option>
            <mat-option value="ens-sup-nivel">Ensino Superior (Graduação)</mat-option>
            <mat-option value="curso-tecnico">Ensino Técnico</mat-option>
            <mat-option value="ens-med-nivel">Ensino Médio</mat-option>
            <mat-option value="ens-fun-nivel">Ensino Fundamental</mat-option>
            <mat-option value="curso-extra">Curso Extra</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="actions">
          <button type="submit" class="custom-primary" mat-raised-button style="margin: 2px; height: 53px"
            [disabled]="!form.valid">
            Salvar
          </button>
        </div>
      </div>
    </form>

    <div class="controls">
      <button mat-stroked-button color="primary" (click)="editable(true)" *ngIf="editMode === false">
        <mat-icon>add</mat-icon>
        Novo curso
      </button>

      <button mat-stroked-button color="warn" (click)="editable(false)" [disabled]="submiting"
        *ngIf="editMode === true">
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
    </div>

    <ng-container *ngIf="editMode === true">
      <form [formGroup]="formEducation" (submit)="submitSchooling()">
        <div class="row" style="margin-top: 20px">
          <mat-form-field appearance="outline">
            <mat-label>Nível educacional</mat-label>
            <mat-select placeholder="Selecione um nivel educacional" formControlName="educationLevel">
              <mat-option value="ens-sup-nivel4">Ensino Superior (Doutorado)</mat-option>
              <mat-option value="ens-sup-nivel3">Ensino Superior (Mestrado)</mat-option>
              <mat-option value="ens-sup-nivel2">Ensino Superior (Pós graduação)</mat-option>
              <mat-option value="ens-sup-nivel">Ensino Superior (Graduação)</mat-option>
              <mat-option value="curso-tecnico">Ensino Técnico</mat-option>
              <mat-option value="ens-med-nivel">Ensino Médio</mat-option>
              <mat-option value="ens-fun-nivel">Ensino Fundamental</mat-option>
              <mat-option value="curso-extra">Curso Extra</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Nome da instituição</mat-label>
            <input type="text" matInput placeholder="Nome da instituição" formControlName="institutionName" />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Nome do curso</mat-label>
            <input type="text" matInput placeholder="Nome do curso" formControlName="courseName" />
          </mat-form-field>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <mat-slide-toggle color="primary" formControlName="currentCourse">Estou atualmente nesse
            curso</mat-slide-toggle>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Data de início</mat-label>
            <input type="text" matInput placeholder="MM/YYYY" formControlName="dateStart" mask="00/0000"
              inputmode="numeric" />
            <mat-error *ngIf="
                formEducation.get('dateStart').errors?.invalidDate === true
              ">Informe uma data válida</mat-error>
            <mat-error *ngIf="formEducation.get('dateStart').errors?.beforeDate === true">Data não pode ser maior que a
              data de término</mat-error>
          </mat-form-field>
        </div>

        <div class="row">
          <ng-container *ngIf="formEducation.get('currentCourse').value === false">
            <mat-form-field appearance="outline">
              <mat-label>Data de término</mat-label>
              <input type="text" matInput placeholder="MM/YYYY" formControlName="dateEnd" mask="00/0000"
                inputmode="numeric" />
              <mat-error *ngIf="formEducation.get('dateEnd').errors?.departure === true">Informe a data de término desse
                curso</mat-error>
              <mat-error *ngIf="
                  formEducation.get('dateEnd').errors?.invalidDate === true
                ">Informe uma data válida</mat-error>
              <mat-error *ngIf="formEducation.get('dateEnd').errors?.maxDate === true">Data não pode ser maior que a
                atual</mat-error>
            </mat-form-field>
          </ng-container>
        </div>

        <div class="actions">
          <button type="submit" class="custom-primary" mat-raised-button
            [disabled]="submiting || formEducation.pristine">
            Salvar
          </button>
        </div>
      </form>
    </ng-container>

    <!-- <ng-container *ngIf="(educations$ | async)?.length === 0">
      <app-empty-content
        text='Clique em "Novo curso" para alterar sua escolaridade'
      ></app-empty-content>
    </ng-container> -->

    <!-- <ng-template #emptyContent>
            <app-empty-content text='Clique em "Novo curso" para adicionar um curso'></app-empty-content>
        </ng-template> -->
  </div>
</div>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
